import {combineReducers} from 'redux';
import products from './products/reducers';
import webmodule from './webmodule/reducers';
import support from './support/reducers';
import generalsettings from './generalsettings/reducer';
import auth from './auth/reducer';
import partner from './partner/reducers';
import eyewear from './eyewear/reducers';

export default combineReducers({
  products,
  webmodule,
  support,
  generalsettings,
  auth,
  partner,
  eyewear,
});
